import React, { useState } from "react";
import HouseMap from "../components/HouseMap";
import StoryContinue from "../components/StoryContinue";
const AboutSection: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const [showMore, setShowMore] = useState(false);
  // Full content split into paragraphs
  const paragraphs = [
    "House of Bombay exists because some cities never leave you. Bombay is one of them.",
    "It is a city that teaches you how to live with others, at crowded tables, on shared benches, in moments that begin with food and end with stories. It doesn’t ask where you come from before it offers you a seat. It feeds first, listens later, and somehow makes room for one more. House of Bombay is our ode to that instinct.",
    "Not a recreation of the city, but a reflection of its spirit, the paradoxes it holds so easily. Old and new. Quiet and kinetic. Comfort and curiosity. Familiar flavours served with a modern pulse. A place where memory and momentum sit side by side.",
    "We built this house as a space of welcome. For those who grew up with Bombay in their bones, and for those meeting it for the first time. For long conversations, shared plates, lingering chai, and meals that feel like they belong to you. Because hospitality, the way Bombay understands it, has never been about perfection. It has always been about generosity. And here, across the ocean, the city finds its table again.",
    "With warmth, House of Bombay",
  ];

  // Show first 2 paragraphs if not expanded
  const visibleParagraphs = expanded ? paragraphs : paragraphs.slice(0, 2);
  return (
    <section className="about-section">
      {/* LETTER SECTION */}

      <div className="about-container">
        <div className="about-content">
          <div className="dear-section">
            <div className="dear-header">
              <span className="dear-line"></span>
              <div className="line-heading">
                <div className="small-line"></div>
                <p className="explore" style={{ fontWeight: "700" }}>
                  DEAR YOU,
                </p>
              </div>
            </div>

            <div className="letter-card">
              <div className="content">
                <br />
                {visibleParagraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}

                {/* Show Read More / Read Less link */}
                {!expanded && (
                  <p>
                    <span
                      style={{
                        color: "#ea6826",
                        cursor: "pointer",
                        borderBottom: "1px solid #ea6826",
                      }}
                      onClick={() => setExpanded(true)}
                    >
                      Read More
                    </span>
                  </p>
                )}
                <br />
                <br />
              </div>
            </div>
            {/* <div className="letter-image">
              <img src="/about-us-banner-m.png" alt="Dear You Letter" />
            </div> */}
          </div>
        </div>
        {/* HOST GRID */}
        <div className="m-hosts-mobile">
          <div className="m-hosts-mobile-container">
            <h2 className="m-hosts-title">Meet Your Hosts</h2>

            <p className="m-hosts-intro">
              Every house carries the imprint of those who imagined it. House of
              Bombay is built by people who were shaped by the city long before
              they decided to serve it.
            </p>

            <div className="m-host-card">
              <div className="m-diamond">
                <img src="/Nishiket.png" alt="Nishiket Parikh" />
              </div>

              <h3 className="m-host-name">Nishiket Parikh</h3>
              <p className="m-host-role">Founder</p>

              <p className="m-host-description">
                Nishiket grew up in Bombay, in and around restaurants,
                conversations, and the quiet understanding that food is never
                just food. It’s how people gather, how days are marked, how
                relationships are built. Over the years, he has owned, launched,
                and operated multiple restaurant brands across Bombay, learning
                the city not just as a diner, but from behind the scenes from
                finding the right location to shaping menus, managing teams, and
                keeping the rhythm of a restaurant alive, day after day. 
              </p>
              <p className="m-host-description">
                House of Bombay is personal for him. It’s an extension of the
                way he understands hospitality, thoughtful, disciplined,
                generous. A place built to last, not rush. A house that feels as
                considered as it is warm.  
              </p>
            </div>

            <div className="m-host-card margin-top-60">
              <div className="m-diamond">
                <img src="/Shivani.png" alt="Co-Founder" />
              </div>

              <h3 className="m-host-name">Shivani Shroff</h3>
              <p className="m-host-role">Co-Founder</p>

              <p className="m-host-description">
                Shivani sees Bombay in details. In colours faded by sun and
                rain. In textures that carry memory. In the way old and new sit
                comfortably side by side. Trained at the London College of
                Fashion, she leads the creative and brand vision of House
                of Bombay, shaping everything from the interiors and visual
                identity to the smallest touchpoints guests interact with. Her
                approach is intuitive but intentional, design that feels
                lived-in, not staged.  
              </p>

              <p className="m-host-description">
                For Shivani, House of Bombay is about translating emotion into
                experience. Making sure the space feels welcoming, layered, and
                quietly expressive, much like the city that inspired it. 
              </p>
            </div>

            {/* third */}
            {/* <div className="m-host-card margin-top-60">
              <div className="m-diamond">
                <img src="/2.png" alt="Nishiket Parikh" />
              </div>

              <h3 className="m-host-name">Chef AB </h3>
              <p className="m-host-role">Chef AB</p>

              <p className="m-host-description">
                Chef Abhijeet Botadkar (popularly known in and outside the
                kitchen as Chef AB) cooks with restraint, respect, and memory. 
                His relationship with Bombay’s food culture runs deep, shaped by
                street flavours, home kitchens, and regional traditions that
                have found a common language in the city. He understands
                that Bombay cuisine is not about one style, but about
                coexistence.  
              </p>
              <p className="m-host-description">
                At House of Bombay, his food doesn’t chase nostalgia or novelty.
                It finds a balance between the two. Familiar dishes are
                approached with care, technique, and clarity, allowing flavours
                to evolve while staying true to their soul. 
              </p>
            </div> */}

            {/* Fourth */}
            <div className="m-host-card margin-top-60">
              <div className="m-diamond">
                <img src="/Krishna.png" alt="Founder" />
              </div>

              <h3 className="m-host-name">Chef Krishna P. Khetle (Chef KK) </h3>
              <p className="m-host-role">Executive Culinary Advisor</p>

              <p className="m-host-description">
                Known across the industry as Chef KK, Krishna P. Khetle brings
                over two decades of culinary and hospitality experience to House
                of Bombay. From beginning his journey as a young commis chef in
                2001 to founding KK Hospitality and helping launch more than 75
                restaurants across India and internationally, he has built a
                reputation for combining culinary excellence with thoughtful
                brand building.
              </p>
              <p className="m-host-description">
                As Executive Culinary Advisor, he brings invaluable perspective
                and mentorship to the house, helping shape a menu that honours
                Bombay’s rich food culture while presenting it through a
                contemporary lens.
              </p>
            </div>
            <div className="m-host-card margin-top-60">
              <div className="m-diamond">
                <img src="/sunil.png" alt="Chef" />
              </div>

              <h3 className="m-host-name">Chef Sunil Gangwal</h3>
              <p className="m-host-role">Culinary Director | Executive Chef</p>

              <p className="m-host-description">
                With over 24 years of experience in luxury hospitality and fine
                dining, Chef Sunil Gangwal is celebrated for his refined
                approach to Indian cuisine, seamlessly blending authentic
                flavors with contemporary culinary artistry. Having led
                prestigious kitchens and food & beverage operations across
                renowned hospitality brands, including leadership roles with
                Marriott, Renaissance, and Hilton, Chef Sunil brings a legacy of
                excellence, innovation, and guest-centric dining experiences.
              </p>
              <p className="m-host-description">
                His culinary philosophy is rooted in honoring tradition while
                elevating it through modern techniques, creating sophisticated
                and memorable experiences for today's discerning guests. 
              </p>
            </div>
          </div>
        </div>
        <HouseMap />
        <StoryContinue />
      </div>
    </section>
  );
};

export default AboutSection;
